
import {Injectable} from "@angular/core";
import {RaEvent} from "./RaEvent";
import {ActivityEvent, ACTIVITY_STATUS, ActivityEventData} from "../event/ActivityEvent";
import {Subject} from "rxjs";

@Injectable()
export class EventBus extends Subject<RaEvent> {

    public startActivityEvent(activityEventData: ActivityEventData): void {
        this.next(new ActivityEvent(ACTIVITY_STATUS.activity_start, activityEventData));
    }

    public endActivityEvent(activityEventData: ActivityEventData): void {
        this.next(new ActivityEvent(ACTIVITY_STATUS.activity_end, activityEventData));
    }

}
